import VueCountdown from '@chenfengyuan/vue-countdown'

export default ({ app, router, Vue }) => {
  Vue.component(VueCountdown.name, VueCountdown)
}
